import { render, staticRenderFns } from "./StudentsTab.vue?vue&type=template&id=711e0dcf&scoped=true&"
import script from "./StudentsTab.vue?vue&type=script&lang=js&"
export * from "./StudentsTab.vue?vue&type=script&lang=js&"
import style0 from "./StudentsTab.vue?vue&type=style&index=0&id=711e0dcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711e0dcf",
  null
  
)

export default component.exports